function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { DraggableItem } from "./common";

// Local Definitions

import "./styles.scss";
const baseClassName = styleNames.base;
const componentClassName = 'drag-and-drop';

/**
 * This is the component description.
 */
const DragAndDrop = ({
  id,
  className: userClassName,
  style,
  as: Wrapper,
  onOrderChange,
  items
  // ...otherProps
}) => {
  const [draggableItems, setDraggableItems] = useState(items);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const handleDrop = (e, dragOverItemIndex) => {
    e.preventDefault();
    const dragItemIndex = e.dataTransfer.getData('text');
    const orderedItems = [...draggableItems];
    const [reorderedItem] = orderedItems.splice(dragItemIndex, 1);
    orderedItems.splice(dragOverItemIndex, 0, reorderedItem);
    setDraggableItems(orderedItems);
    onOrderChange?.(orderedItems);
    setDragOverIndex(null);
  };
  return /*#__PURE__*/React.createElement(Wrapper, {
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
    // {...otherProps}
  }, draggableItems.map(({
    identifier,
    disabled,
    Content,
    ...rest
  }, index) => /*#__PURE__*/React.createElement(DraggableItem, _extends({
    className: dragOverIndex === index && 'drag-over',
    draggable: true,
    onDrop: e => handleDrop(e, index),
    onDragOver: e => {
      e.preventDefault();
      setDragOverIndex(index);
    },
    index: index,
    key: identifier
  }, rest), Content)));
};
DragAndDrop.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The html element to use to display this component.
   */
  as: PropTypes.string,
  /**
   * The node list of items to be dragged around
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    Content: PropTypes.node.isRequired,
    identifier: PropTypes.string.isRequired,
    as: PropTypes.string
  })).isRequired,
  /*
  * A function to be called when the draggable items are re-ordered
  */
  onOrderChange: PropTypes.func
};
DragAndDrop.defaultProps = {
  as: 'ul'
};
DragAndDrop.DraggableItem = DraggableItem;
export default DragAndDrop;